"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalDateTimeFilter = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 *
 * @depends buildium.common.Locale
 * @depends manager.framework.common.Settings
 *
 */

var LocalDateTimeFilter = exports.LocalDateTimeFilter = function exports(Locale, Settings) {
  function formatDateTimeWithTimeZone(input) {
    // If it has a time in the ISO string, then account for timezone and format without time part.
    if (typeof input === 'string' && input.indexOf('T') > 0) {
      // We have to be working with UTC dates to apply the offset correctly so if we get unspecified datetimes
      // in here we have to assume UTC. If they weren't UTC then the time will always be calculated wrong here
      // so it is a somewhat safe assumption.
      var utcInput = input.indexOf('Z') > 0 ? input : "".concat(input, "Z");
      var momentTime = (0, _momentTimezone["default"])(utcInput);
      var localZoneUtcOffset = momentTime.utcOffset() * -1 * 60 * 1000;

      // Add or subtract the account offset plus the local machine offset to the UTC date.
      // If the local machine's offset and the account's time zone offset match,
      // then nothing needs to be added as the new Date(momentTime) instruction will automatically
      // parse the date using the local machine settings.
      momentTime.add(localZoneUtcOffset + Settings.SubscriberSettingsInfo.TimeZoneOffset, 'milliseconds');
      return Locale.formatDateTime(new Date(momentTime));
    }
    return Locale.formatDateTime(input);
  }

  // Optional parameter useCustomerTimezone may be passed (true/false) so that the subscriber account timezone is used.
  return function filterDateTime(input, useCustomerTimezone) {
    if (typeof useCustomerTimezone !== 'undefined' && typeof useCustomerTimezone !== 'boolean') {
      throw new Error('The expected type for the useCustomerTimezone parameter is a boolean.');
    }
    if (useCustomerTimezone) {
      return formatDateTimeWithTimeZone(input);
    }
    return Locale.formatDateTime(input);
  };
};
LocalDateTimeFilter.$inject = ['Locale', 'Settings'];